<template>
    <v-card
        :ripple = "false"
        flat
        rounded
    >
        <div
            class = "lm-border pa-3 pt-3"
            style = "position: relative"
        >
            <div
                class = "v-flex"
                style = "justify-content: space-between; height: 22px"
            >
                <div style="font-size: 15px; padding-top: 1px;" class="v-flex">
                    <div class="primary--text">
                        {{ site.fabricNo }}
                    </div>
                </div>
                <v-spacer/>
                <div class="site-customer">
                   {{ site.customer.name }}
                </div>
                <div style="margin-top: -2px; margin-right: -7px;">
                    <c-site-icon
                        :site="site"
                    />
                </div>
            </div>
            <v-divider class="mt-1 mb-1" />
            <div class="card-subtitle">
                {{ site.street }}, {{ site.zip }} {{ site.city }}
            </div>
            <div class="card-subtitle">
                {{ site.ve }}  {{ site.ve && site.ve2 ? ' / ' : ''  }}  {{ site.ve2 }}
            </div>
        </div>
    </v-card>
</template>

<script>

import CSiteIcon from "@/modules/msd/unit/components/controlls/CSiteIcon";

export default {
    name: "CSiteSelectionCard",
    components: {
        CSiteIcon
    },
    props: {
        site: {
            default: function () {
                return {
                }
            },
        },
    },


    data: () => ({
        showMenu : false
    }),


    computed: {
        active () {
            if (!this.site.status) {
                return false;
            }

            return this.site.status.id === 1;
        },
    },
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.site-customer {
    font-size: 13px;
    padding-right: 5px;
    padding-top: 4px;
    max-width: 175px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

</style>